import { z } from 'zod';
import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema, baseAnswerSchema, baseTargetSchema } from './base.structure.js';
import { blockSchema } from './block.js';

const classificationStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasMedia = query.media?.length > 0;
    if (hasMedia) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  }),
  options: z.array(blockSchema).min(2, {
    message: ErrorTypes.MIN_OPTIONS
  }).max(20, {
    message: ErrorTypes.MAX_OPTIONS
  }),
  answer: z.array(baseAnswerSchema).min(2, {
    message: ErrorTypes.MIN_TARGETS
  }).max(4),
  targets: z.array(baseTargetSchema).min(2, {
    message: ErrorTypes.MIN_TARGETS
  }).max(4)
}).refine((structure) => {
  let valid = true;
  const allTargets = new Map(structure.targets.map((item) => [item.id, item]));
  for (let i = 0; i < structure.answer.length; i++) {
    const { optionId, targetId } = structure.answer[i];
    if (optionId.length) {
      const group = allTargets.get(targetId);
      if (!group?.name) {
        valid = false;
        break;
      }
    }
  }
  return valid;
}, {
  message: ErrorTypes.EMPTY_CATEGORY
}).refine(
  (structure) => {
    let valid = true;
    const filteredTargets = structure.targets.filter((item) => !!item.name);
    const uniqueTargetsNameSet = new Set(filteredTargets.map((item) => item.name));
    if (uniqueTargetsNameSet.size !== filteredTargets.length) {
      valid = false;
    }
    return valid;
  },
  {
    message: ErrorTypes.DUPLICATE_CATEGORY
  }
);

export { classificationStructureSchema };
